import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        //Dades generals
        urlAPI: 'http://grupbasis.com/basistime/api/',
        appObject: {},
        authenticated: false,

        //contador cronòmetre
        time: 0,
        time_formated: '',
        isRunning: false,
        interval: null
    },
    mutations: {
        //Les mutacions són funcions, les úniques que poden modificar "state"
        updateState( state, payload){
            console.log('aquest es el payload que rebem: ', payload)
            Object.assign(state.appObject, payload) //Combinem els dos objectes, l'existent i el que passem (per no eliminar dades ja introduides, només actualitzar)
            state.authenticated = true
        },
        updateField(state, payload){
            state[payload.field] = payload.value;
        },
        resetState( state){
            state.appObject = {}
            state.authenticated = false
        }
    },
    getters: {
        isAuthenticated( state ){
            return state.authenticated
        }
    },
    actions: {
        //Guardem la data al localStorage
        setStorage( store, payload ){
            console.log('aqui hem entrat i el payload és:' , payload)
            this.commit('updateState', payload) //Fem un commit per acutalitzar les dades de l'state (mutació)
            console.log('hem entrat al setStorge, i guardem això', this.state.appObject);
            localStorage.setItem('appObject', JSON.stringify( this.state.appObject )); //Per guardar la "data" al localstorage l'hem de passar a "string"
        },
        async getStorage( store ){

            let info = JSON.parse(localStorage.getItem('appObject')); //Agafem la info com a "string" del localstorage i la passem a objecte
            console.log('INFO desde el getStorage', info)
            if(info) this.commit('updateState', info) //Fem un commit per acutalitzar les dades de l'state (mutació)
            else this.commit('resetState'); //Fem un commit per eliminar la data (mutació)

        },
        //cronòmetre
        toggleTimer( store ) {
            if (this.state.isRunning) {
                clearInterval(this.state.interval);
                //Netegem el temps
                console.log('netegem')
                this.commit('updateField', {field: 'time', value: 0})
                this.commit('updateField', {field: 'time_formated', value: ''})
                console.log(this.state.stime)

            } else {
                let interval = setInterval(() => {this.dispatch('incrementTime')}, 1000);
                this.commit('updateField', {field: 'interval', value: interval})
            }
            let isRunning = !this.state.isRunning
            this.commit('updateField', {field: 'isRunning', value: isRunning})
        },
        startTimer(){
            let interval = setInterval(() => {this.dispatch('incrementTime')}, 1000);
            this.commit('updateField', {field: 'interval', value: interval})

            this.commit('updateField', {field: 'isRunning', value: true})
        },
        stopTimer(){
            clearInterval(this.state.interval);
            this.commit('updateField', {field: 'time', value: 0})
            this.commit('updateField', {field: 'time_formated', value: ''})
            this.commit('updateField', {field: 'isRunning', value: false})
        },
        incrementTime() {
            let time = this.state.time
            time = parseInt(time) + 1
            this.commit('updateField', {field: 'time', value: time})

            //Li donem format a l'hora
            let h = Math.floor(time / 3600);
            let m = Math.floor(time % 3600 / 60);
            let s = Math.floor(time % 3600 % 60);
            
            let time_formated = ('0' + h).slice(-2) + ":" + ('0' + m).slice(-2) + ":" + ('0' + s).slice(-2);
            this.commit('updateField', {field: 'time_formated', value: time_formated})
        }        
        //Agafem la data del localStorage
/*        getStorage( state ){

            return new Promise((resolve, reject) => {

                state.appObject = JSON.parse(localStorage.getItem('appObject')); //Agafem la info com a "string" del localstorage i la passem a objecte

                if(state.appObject) resolve(state.appObject)
                else reject("No s'ha trobat res")

            })
        },*/

    }
})
